import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
    Avatar,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox,
    Grid,
    Divider,
    Button,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    Tabs,
    Box,
    Tab,
    AppBar,
    colors
} from '@material-ui/core';
import { delete_showroom_timetable } from '../../../../api/API';
import TableEditBar from '../../../../components/TableEditBar/TableEditBar';
import moment from 'moment';
import './timetabletablelist.css';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: '24px',
    },

    content: {
        padding: 0
    },

    inner: {
        padding: '3%',
        minWidth: 700,
    },

    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },

    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },

    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },

    scroll: {
        overflow: "auto",
    },

    leftIcon: {
        marginRight: theme.spacing.unit,
    },


}));

export default function TimetableTableList(props) {

    const day_labels = {
        day_0: 'Monday',
        day_1: 'Tuesday',
        day_2: 'Wednesday',
        day_3: 'Thursday',
        day_4: 'Friday',
        day_5: "Saturday",
        day_6: 'Sunday',
    };
    const { className, showroom_timetable, property_id, showroom_agencies, ...rest } = props;
    const bookings = props.bookings ? props.bookings : [];
    const classes = useStyles();

    const [selectedBookings, setSelectedBookings] = useState([]);
    const [timetable, setTimetable] = useState(showroom_timetable.standard);
    const [specialTimetable, setSpecialTimetable] = useState(showroom_timetable.special);
    const [value, setValue] = useState({
        currentTab: 0
    });
    const handleChange = (event, newValue) => {
        setValue({
            currentTab: newValue
        });
    };
    const [booking, setBooking] = useState();
    const [page, setPage] = useState();
    const [agencies, setAgencies] = useState(showroom_agencies);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    useEffect(() => {
        setTimetable(props.showroom_timetable.standard);
        setSpecialTimetable(props.showroom_timetable.special);
        setAgencies(props.showroom_agencies);
        console.log("use ef");
        console.log(props.showroom_timetable.special);
    });
    const handleChangePage = (event, page) => {
        setPage(page);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(event.target.value);
    };

    const handleFilter = () => { };
    const handleSearch = () => { };


    const handleDelete = (timeslot_id) => {
        let cfm = window.confirm("Are you sure you want to delete this slot ? ");
        if (cfm) {
            let data = delete_showroom_timetable(timeslot_id);
            props.refresh_data();
            // if (data) {
            //     window.location.href = window.location.href;
            // }
        }
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    return (

        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
            >
                {/* {bookings.length} Records found. Page {page + 1} of{' '}
            {Math.ceil(bookings.length / rowsPerPage)} */}
            </Typography>
            <Card>
                <CardHeader
                    //   action={<GenericMoreButton />}
                    title="Time Slots"
                    action={
                        <RouterLink to={"/showroom/createtimetableDemo/" + props.property_id}>
                            <Button variant="contained">
                                <AddIcon />

                            </Button>
                        </RouterLink>

                    }
                />
                <Divider />
                {timetable ?
                    <CardContent className={classes.content}>
                            <div className={classes.inner} style={{
                                minWidth: "unset"
                            }}>
                                <Tabs value={value.currentTab} onChange={handleChange}>
                                    <Tab label="Standard"  {...a11yProps(0)}></Tab>
                                    <Tab label="Special Days"  {...a11yProps(1)}></Tab>
                                </Tabs>
                                <TabPanel value={value.currentTab} index={0}>
                                    {Object.entries(timetable).map((slot, index) => (
                                        <React.Fragment>
                                            <h3>{day_labels[slot[0]]}</h3>
                                            <Grid container style={{
                                                backgroundColor: "#fafafa",
                                                padding: "14px 0"
                                            }}
                                                className="timetabelGrids"
                                            >
                                                <Grid item xs={2}>

                                                </Grid>
                                                {agencies.map((row) => (
                                                    <Grid item xs={1}>
                                                        <div>
                                                            {(row.short_name)}
                                                        </div>
                                                    </Grid>
                                                ))
                                                }
                                                <Grid item xs={10 - agencies.length}>

                                                </Grid>
                                            </Grid>
                                            {
                                                slot[1].map((row) => (
                                                    <Grid container style={{
                                                        padding: "14px 6px",
                                                        borderBottom: "1px solid #eaeaea"
                                                    }}>
                                                        <Grid item xs={2}>
                                                            {moment('2020-02-02 ' + row.start_time).format("hh:mm a")}<br></br>{moment('2020-02-02 ' + row.end_time).format("hh:mm a")}
                                                        </Grid>

                                                        {
                                                            row.type == 1 ?
                                                                <React.Fragment>
                                                                    {
                                                                        agencies.map((agency_row, agency_row_index) => (
                                                                            <Grid item xs={1} >
                                                                                <React.Fragment>
                                                                                    <React.Fragment>
                                                                                        {
                                                                                            row.agencies.map((a_row) => (
                                                                                                <div>
                                                                                                    {
                                                                                                        a_row.agency_id == agencies[agency_row_index].agency_id ?
                                                                                                            a_row.max_appointment : ''}


                                                                                                </div>
                                                                                            ))
                                                                                        }
                                                                                    </React.Fragment>
                                                                                </React.Fragment>
                                                                            </Grid>
                                                                        ))
                                                                    }
                                                                </React.Fragment>
                                                                :
                                                                <Grid item xs={agencies.length} style={{ display: "flex", justifyContent: "space-evenly" }}>
                                                                    <React.Fragment>
                                                                        <div style={{ textAlign: "center" }}>
                                                                            <b>First Come First Serve</b><br />
                                                                            {row.fcfs_appointment} slots
                                                                        </div>
                                                                    </React.Fragment>
                                                                </Grid>
                                                        }

                                                        <Grid item xs={10 - agencies.length} style={{
                                                            textAlign: 'center'
                                                        }} 
                                                        className="timetable_buttons"
                                                        >
                                                            <RouterLink
                                                                to={"/edittimetable/" + row.timeslot_id}>

                                                                <EditIcon style={{ marginRight: 10 }} />
                                                            </RouterLink>

                                                            <DeleteIcon onClick={(e) => {
                                                                handleDelete(row.timeslot_id);
                                                            }} />
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                        </React.Fragment>
                                    ))}


                                </TabPanel>
                                <TabPanel value={value.currentTab} index={1}>
                                    <Button
                                        onClick={props.openaddspecialday}
                                        style={{
                                            float: 'right'
                                        }}
                                        variant="contained">
                                        <AddIcon className={classes.leftIcon} />
                                        Add Special Day
                                         </Button>
                                    <br></br><br></br><br></br>

                                    {Object.entries(specialTimetable).map((slot, index) => (
                                        <React.Fragment>
                                            <h3>{moment(slot[1][0]['special_date']).format("DD/MM/YYYY") + " : " + slot[1][0]['special_title']}</h3>
                                            <Grid container style={{
                                                backgroundColor: "#fafafa",
                                                padding: "14px 0"
                                            }}
                                                className="timetabelGrids"
                                            >
                                                <Grid item xs={2}>

                                                </Grid>
                                                {agencies.map((row) => (
                                                    <Grid item xs={1}>
                                                        <div>
                                                            {(row.short_name)}
                                                        </div>
                                                    </Grid>
                                                ))
                                                }
                                                <Grid item xs={10 - agencies.length}>

                                                </Grid>
                                            </Grid>
                                            {
                                                slot[1].map((row) => (
                                                    <Grid container style={{
                                                        padding: "14px 6px",
                                                        borderBottom: "1px solid #eaeaea"
                                                    }}>
                                                        <Grid item xs={2}>
                                                            {moment('2020-02-02 ' + row.start_time).format("hh:mm a")}<br></br>{moment('2020-02-02 ' + row.end_time).format("hh:mm a")}
                                                        </Grid>

                                                        {
                                                            row.type == 1 ?
                                                                <React.Fragment>
                                                                    {
                                                                        agencies.map((agency_row, agency_row_index) => (
                                                                            <Grid item xs={1} >
                                                                                <React.Fragment>
                                                                                    <React.Fragment>
                                                                                        {
                                                                                            row.agencies.map((a_row) => (
                                                                                                <div>
                                                                                                    {
                                                                                                        a_row.agency_id == agencies[agency_row_index].agency_id ?
                                                                                                            a_row.max_appointment : ''}


                                                                                                </div>
                                                                                            ))
                                                                                        }
                                                                                    </React.Fragment>
                                                                                </React.Fragment>
                                                                            </Grid>
                                                                        ))
                                                                    }
                                                                </React.Fragment>
                                                                :
                                                                <Grid item xs={agencies.length} style={{ display: "flex", justifyContent: "space-evenly" }}>
                                                                    <React.Fragment>
                                                                        <div style={{ textAlign: "center" }}>
                                                                            <b>First Come First Serve</b><br />
                                                                            {row.fcfs_appointment} slots
                                                                        </div>
                                                                    </React.Fragment>
                                                                </Grid>
                                                        }

                                                        <Grid item xs={10 - agencies.length} 
                                                        className="timetable_buttons"
                                                        style={{
                                                            textAlign: 'center'
                                                        }}>
                                                            <RouterLink
                                                                to={"/edittimetable/" + row.timeslot_id}>

                                                                <EditIcon style={{ marginRight: 10 }} />
                                                            </RouterLink>

                                                            <DeleteIcon onClick={(e) => {
                                                                handleDelete(row.timeslot_id);
                                                            }} />
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                        </React.Fragment>
                                    ))}
                                </TabPanel>

                            </div>


                    </CardContent>
                    : ''
                }
            </Card >

        </div >

    );


}